// extracted by mini-css-extract-plugin
module.exports = {"container":"AddUser_container__15674","form":"AddUser_form__13k88","input":"AddUser_input__3lSlQ","btnContainer":"AddUser_btnContainer__24TJY","button":"AddUser_button__2RG2C"};